/* eslint-disable react/require-default-props */
import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import {
  getSimSelectionImageByTitle,
  getSimSelectionPageContent,
  getSimSelectionSlugValue
} from '@apps/utils/simSelectionContent'
import { ApplicationContext, APPLICATION_STATE } from '@apps/contexts/ApplicationContext'
import { useSelector } from 'react-redux'
import { ProductFeature, Typography } from '@telus/koodo-ui-kit'

const SIM_CARD_LOCATION_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: '20px'
}
const SIM_CARD_DETAILS_TOKENS = {
  color: '#000000',
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: '20px'
}

const SIMCardNumber = ({ className = '', userType = '' }) => {
  const { [APPLICATION_STATE.CURRENT_LANGUAGE]: language } = useContext(ApplicationContext)
  const { pageContent } = useSelector((state) => state.common.content)

  const localizedPage = getSimSelectionPageContent(pageContent, language, userType)
  const { shortTextFields, images } = localizedPage || {}

  const content = useMemo(() => {
    if (!shortTextFields && !images) return {}
    const simCardFrontBackImage = getSimSelectionImageByTitle(
      images,
      'sim-card-front-back',
      userType
    )

    return {
      simCardBelowImg: simCardFrontBackImage?.url,
      simCardBelowImgText: simCardFrontBackImage?.altText,
      simCardNumberLocation: getSimSelectionSlugValue(
        shortTextFields,
        'sim-card-number-location',
        userType
      ),
      simCardNumberDetails: getSimSelectionSlugValue(
        shortTextFields,
        'sim-card-number-details',
        userType
      )
    }
  }, [shortTextFields, images, userType, language])

  return (
    <div className={className}>
      <ProductFeature
        image={
          content?.simCardBelowImg
            ? {
                src: content.simCardBelowImg,
                alt: content?.simCardBelowImgText || ''
              }
            : undefined
        }
        mediaMaxWidth={420}
        tokens={{
          backgroundColor: '#f2f2f2',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0
        }}
        testId="sim-card-number-product-feature"
      >
        <div
          data-contentful-slug="sim-card-number-location"
        >
          <Typography
            variant={{ size: 14, bold: true, color: '#000000' }}
            tokens={SIM_CARD_LOCATION_TOKENS}
          >
            {content?.simCardNumberLocation}
          </Typography>
        </div>
        <div
          data-contentful-slug="sim-card-number-details"
        >
          <Typography
            variant={{ size: 14, color: '#000000' }}
            tokens={SIM_CARD_DETAILS_TOKENS}
          >
            {content?.simCardNumberDetails}
          </Typography>
        </div>
      </ProductFeature>
    </div>
  )
}

SIMCardNumber.propTypes = {
  className: PropTypes.string,
  userType: PropTypes.string
}

export default SIMCardNumber
